// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2ogiM","inputWrap":"CustomTip_inputWrap__2_WI-"};